import { render } from "./categoriesPage.vue?vue&type=template&id=ab2684b6"
import script from "./categoriesPage.vue?vue&type=script&lang=js"
export * from "./categoriesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__